module.exports = __webpack_public_path__ + "img/right-arrow.fd8bbb21.svg";